'use client';

import { LogoutButton } from 'components/account/buttons';
import Anchor from 'components/typography/anchor';
import { Menu, X } from 'lucide-react';
import Modal from 'react-modal';
import config from 'siteconfig';

export const NavToggle = ({ onClick, isOpen }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className="dark:white absolute top-5 right-5 anchor-nav"
      aria-label={isOpen ? 'Close navigation' : 'Open navigation'}
    >
      {isOpen ? (
        <X size={24} strokeWidth={2} />
      ) : (
        <Menu size={24} strokeWidth={2} />
      )}
    </button>
  );
};

export const NavModal = ({ navIsOpen, closeModalFn }) => {
  // The test environment doesn't have a DOM, so we need to mock this.
  // but doing so in the tests breaks the tests, so we do it here.
  // See header.test.js for more info.
  if (process.env.NODE_ENV !== 'test') {
    if (typeof window !== 'undefined') {
      // App Router
      Modal.setAppElement(document.getElementById('root'));
    } else {
      // Pages Router
      Modal.setAppElement('#root');
    }
  }
  return (
    <Modal
      isOpen={navIsOpen}
      onRequestClose={closeModalFn}
      className={
        'fixed right-0 h-screen max-w-80 min-w-48 overflow-scroll bg-white px-2 shadow-xl dark:bg-stone-950/80'
      }
      overlayClassName={
        'fixed inset-0 bg-linear-to-tr from-purple-800/80 to-fuchsia-900/80 transition-opacity duration-300 z-10'
      }
      contentLabel="Navigation Modal"
    >
      {/* Tailwind: .ReactModal__Overlay--before-close .ReactModal__Overlay--after-open */}
      <NavToggle onClick={closeModalFn} isOpen={navIsOpen} />

      <nav aria-label="secondary">
        <Anchor className="mt-16 button-navigation" href="/">
          Home
        </Anchor>
        <Anchor className="button-navigation" href="/chat">
          Chat with Resistbot
        </Anchor>
        <Anchor className="button-navigation" href="/premium/coins">
          Buy Coins
        </Anchor>
        <Anchor className="button-navigation" href="/premium">
          Membership
        </Anchor>
        <Anchor className="button-navigation" href="/petitions">
          Petitions
        </Anchor>
        <Anchor className="button-navigation" href="/letters">
          Open Letters
        </Anchor>
        <Anchor className="button-navigation" href="/officials">
          Officials
        </Anchor>
        <Anchor className="button-navigation" href="/guide">
          Guide
        </Anchor>
        <Anchor className="button-navigation" href="/about">
          Help
        </Anchor>
        <Anchor className="button-navigation" href="/news">
          News
        </Anchor>
        <Anchor
          className="button-navigation"
          href={config.shopUrls.cottonBureau}
        >
          Shop
        </Anchor>
        <LogoutButton />
      </nav>
    </Modal>
  );
};
